import { IDialog } from './IDialog';
import { OnInit, ElementRef, Directive } from '@angular/core';

@Directive()
export class DialogBottomScreenComponentContent implements IDialog {
    private marginSide: string;
    private targetElement: any;

    constructor(
        protected element: ElementRef, 
        protected containerSelector: string = '.modal-bottom-screen'
    ) {}

    ngOnInit() {

        $(this.element.nativeElement).parents('.cdk-overlay-pane').addClass(this.containerSelector.replace(/\./gi, ''));

        this.targetElement = $(this.element.nativeElement).parents('.mat-dialog-container').parents('.cdk-overlay-pane');

        $('.cdk-global-overlay-wrapper').addClass('modal-bottom-screen-flex');

        $(this.element.nativeElement).find(this.containerSelector).show();
        this.targetElement.css({ 'margin-bottom': '-120%' }).animate({ 'margin-bottom': '0' }, 'slow');
    }

    close(dialogReference: any, result: any) {

        $(this.element.nativeElement).find(this.containerSelector).show();
        this.targetElement.css({ 'margin-bottom': '0' }).animate({ 'margin-bottom': '-120%' }, 'slow');

        //espera a animação de saída
        setTimeout(function () {
            dialogReference.close(result);
        }, 800);
    }
}